<script setup lang="ts">
import Logo from '@/assets/svg/logo.svg'
import NebulaLogo from '@/assets/svg/nebula.svg'
import AppCard from '@/components/atoms/cards/AppCard.vue'
import AppDarkMode from '@/components/molecules/dark-mode/AppDarkMode.vue'
import AppLanguage from '@/components/molecules/language/AppLanguage.vue'
import AuthBackground from '@/components/atoms/backgrounds/AuthBackground.vue'
import { useThemeStore } from '@/stores/useThemeStore'
import { computed } from 'vue'

const themeStore = useThemeStore()
const isDark = computed(() => themeStore.isDark)
</script>

<template>
  <div class="w-full h-full flex flex-col bg-neutral-100 dark:bg-black">
    <div class="flex-1 grid grid-cols-1 md:grid-cols-2">
      <!-- Left side: Form with grid layout -->
      <article class="grid grid-rows-[auto_1fr_auto] h-screen px-4 md:px-6">
        <!-- Top: Buttons aligned to end -->
        <div class="flex items-end justify-end py-2 md:py-3">
          <div class="flex items-center gap-2">
            <AppLanguage />
            <AppDarkMode />
          </div>
        </div>

        <!-- Middle: Card with slot (centered) -->
        <div class="flex items-center justify-center">
          <app-card class="min-w-xs max-w-xs md:min-w-88">
            <template #title>
              <div class="flex justify-center items-center py-4">
                <logo class="w-32 h-32 text-(--p-primary-color)" />
              </div>
            </template>
            <template #content>
              <div class="flex flex-col pb-6">
                <slot />
              </div>
            </template>
          </app-card>
        </div>

        <!-- Bottom: Nebula branding -->
        <div class="flex flex-col items-center gap-3 py-4">
          <NebulaLogo class="w-24 h-auto text-(--p-primary-color)" />
          <div class="text-center text-xs text-(--p-text-muted-color)">
            <p>© Copyright 2015-2026.</p>
            <p>Todos los derechos reservados.</p>
          </div>
        </div>
      </article>

      <!-- Right side: Background -->
      <section
        class="relative hidden h-screen w-full items-center justify-center bg-cover bg-center md:flex"
      >
        <AuthBackground
          :theme="isDark ? 'dark' : 'light'"
          pattern="grid"
          :random-positions="true"
        />
        <Logo class="relative z-10 h-40 w-40 text-(--p-primary-color)" />
      </section>
    </div>
  </div>
</template>
